/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { grid } from '@coop/ole/styles';
import { breakpointsPhablet } from 'src/utils/customBreakpoints';

type Content = JSX.Element | '*.png' | JSX.IntrinsicElements['picture'];

interface ScreenAssets {
  SMElement: Content;
  MDElement: Content;
  PhabletElement?: Content;
  LGElement: Content;
  XLElement?: Content;
}

function breakpointToNumber(bp: string): number {
  return Number(bp.slice(0, -2));
}

export const switchAssetBasedOnScreenSize = (
  screenWidth: number,
  screenAssets: ScreenAssets
) => {
  const {
    SMElement,
    PhabletElement,
    MDElement,
    LGElement,
    XLElement
  } = screenAssets;

  if (screenWidth >= breakpointToNumber(grid.breakpoints.xl)) {
    if (XLElement) {
      return XLElement;
    }

    return LGElement;
  } else if (
    screenWidth < breakpointToNumber(grid.breakpoints.xl) &&
    screenWidth >= breakpointToNumber(grid.breakpoints.lg)
  ) {
    return LGElement;
  } else if (
    screenWidth < breakpointToNumber(grid.breakpoints.lg) &&
    screenWidth >= breakpointToNumber(grid.breakpoints.md)
  ) {
    return MDElement;
  } else if (
    screenWidth < breakpointToNumber(grid.breakpoints.md) &&
    screenWidth >= breakpointToNumber(breakpointsPhablet)
  ) {
    if (PhabletElement) {
      return PhabletElement;
    }
    return MDElement;
  } else if (
    screenWidth < breakpointToNumber(breakpointsPhablet) &&
    screenWidth >= breakpointToNumber(grid.breakpoints.sm)
  ) {
    return SMElement;
  } else if (screenWidth < breakpointToNumber(grid.breakpoints.sm)) {
    return SMElement;
  }
};
